module.exports = __webpack_public_path__ + "img/saxobank.92859b2b.png";